import { MaritalStatus } from 'types';
import { form } from 'data';
interface Option<T> {
  value: T;
  label: string;
  hintText?: string;
}
export const maritalStatusOptions: Option<MaritalStatus>[] = (form.deceased
  .maritalStatusOptions as MaritalStatus[]).map(value => ({ value, label: value }));
